import * as Sentry from '@sentry/nuxt';
import { useClient } from '~/stores/client';

export default defineNuxtPlugin({
  name: 'sentry-user',
  dependsOn: ['sentry-client-integrations'],
  setup() {
    if (!useRuntimeConfig().public.sentryDsn) return;
    const client = useClient();
    // A stable account id joins assessor sessions to API errors; never attach the auth store or its tokens.
    watch(
      () => [client.id, client.role, client.activeCompany?.id] as const,
      ([id, role, companyId]) => {
        Sentry.setUser(id ? { id } : null);
        Sentry.setTags({ 'user.role': String(role), 'company.id': companyId ?? 'none' });
      },
      { immediate: true },
    );
  },
});
